<template>
    <div class=".container-fluid full-height">
        <NavBar></NavBar>

        <div class="KSpinner" v-if="isInitiating">                    
            <div class="spinner-border text-info"></div>
            <h2 class="LoadingText">Loading....</h2>
        </div>

        <div class="d-flex justify-content-center" v-else>
               
            <div class="col-sm-12 col-md-6 col-lg-4 col-xl-3" style="margin-top:30px;">

                <div class="iscreentitleDiv">
                    <h2 v-if="activeMode == 'new'" class="iscreentitle">Create {{ entityName}}</h2>
                    <h2 v-if="activeMode == 'edit'" class="iscreentitle">Edit {{ entityName}}</h2>
                </div>

                <form  @submit.prevent="submit">
        
                    <div class="form-group required text-left">
                        <label for="vname" class="ilabel">Name</label>
                        <input type="text" class="form-control itextinput" id="vname" v-model="object.name" required maxlength = "150" :disabled="activeMode == 'view'">
                    </div>

                    <div class="form-group required text-left">
                        <label for="vname" class="ilabel">Short Name</label>
                        <input type="text" class="form-control itextinput" id="vname" v-model="object.shortName" required maxlength = "150" :disabled="activeMode == 'view'">
                    </div>

                    <div class="form-group required text-left">
                        <label for="vflag" class="ilabel" >Client</label>
                        <b-form-select class = "iselect" v-model="object.client" :options="clients" required :disabled="activeMode == 'view'"></b-form-select>
                    </div>

                    <div class="form-group text-left">
                        <label for="collarSize" class="ilabel">Upload Documents</label>
                        <button v-if="documents != undefined && documents.length != 0" class="btn btn-success btn-block ibutton" type="button" @click="showFileUploadsWindow('CBA', '',object.id, documents)"><font-awesome-icon icon="file-pdf" size="sm"/>   Manage</button>
                        <button v-else class="btn btn-info btn-block ibutton" type="button" @click="showFileUploadsWindow('CBA', '', object.id, documents)"><font-awesome-icon icon="file-pdf" size="sm"/>   Upload Documents</button>
                    </div>
                                    
                    
                    <div class="d-flex justify-content-center " style="padding-top:10px;" v-if="activeMode!='view'">
                        <button type="submit" class="btn btn-primary ibutton mr-3"  :disabled="this.isLoading">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="this.isLoading"></span>
                            <font-awesome-icon icon="plus" size="sm"/>
                            {{ getSubmitBtnTxt }}
                        </button>
                    </div>                    

                </form>                

            </div>        
        </div>

        <!-- ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
        <!-- ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
        <!-- /////////////////////////////////////////////////// FILE UPLOAD ////////////////////////////////////////////////////////////// -->
        <!-- ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
        <!-- ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
        
        <v-dialog
            v-model="showFileUpload"
            persistent
            max-width="1600px"
            min-width="1000px"
            width="auto"
        >      
            <v-card>
                <v-toolbar
                dark
                color="primary"
                >                            
                <v-toolbar-title>Manage Files</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn
                            icon
                            dark
                            @click="showFileUpload = false"
                        >
                            <font-awesome-icon icon="window-close" size="lg"/>
                        
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
            
                <FileUploadWindow :fileInfo="fileUploadFileInfo" :parentInfo="fileUploadParentInfo" :mode="activeMode" :visible="showFileUpload" :max_file_size_MB="10"></FileUploadWindow>
                
            </v-card>
            
        </v-dialog>

        <v-snackbar v-model="showSnackbar" >
            {{ snackBarText }}
            <template v-slot:action="{ attrs }"> <v-btn :color="snackbarColor" text v-bind="attrs" @click="showSnackbar = false">Close</v-btn></template>
        </v-snackbar>
        <Footer class="footerStickedToBottom" ></Footer> 
    </div>    
</template>

<script>

import BasicForm from '@/components/mixins/BasicForm';
import FileUploadMixin from '@/components/mixins/FileUploadMixin';
import FileUploadWindow from "@/components/FileUpload";
import Utils from '@/utils/util.js';
import dataStore from '../firebase/dataStore';

export default {   
    name: 'CBA',  
    data() {
        return {

            entityName:"CBA",

            object:{
                id:'',
                name:'',                    
                shortName:'',                    
                client:'',                    
                createdBy:'',
                createdAt:'',
                modifiedBy:'',
                modifiedAt:'',
            },

            documents:[],
            deletedDocuments:[],

            clients:[],

            CBADocsFileInfo : "CBADocsFileInfo",
        }
    },
    components: {  
        FileUploadWindow,  
    },
    mixins: [BasicForm, FileUploadMixin],
    computed: {
    },
    created() {
    },
    props:{       
    }, 
    methods: {  
        //Upload files
        async uploadDocuments(){
            const fileUploadStatus = await this.uploadFiles(this.documents, this.CBADocsFileInfo);                     
            return fileUploadStatus;
        },
        async beforeCreate(){
            const res = await this.uploadDocuments();
            return res;
        },
        async beforeUpdate(){
            const res = await this.uploadDocuments();
            return res;
        },
        async afterFetchObject(id){
            const documentsFileInfo = await dataStore.getAll(this.CBADocsFileInfo, [['parentID', '==', id]], []);
            for(const doc of documentsFileInfo){this.documents.push(doc)}
        },
        addAdditionalItemsToBatch(DBBatch){
            this.documents.forEach(async doc => {                
                // Prepare object to be uploaded
                const uploadDoc = Object.assign({}, doc);
                if(uploadDoc.status == 'New'){
                    uploadDoc.status = 'Active';
                    dataStore.addToBatch(DBBatch, this.CBADocsFileInfo, true, uploadDoc);
                }else{
                    dataStore.addToBatch(DBBatch, this.CBADocsFileInfo, false, uploadDoc);
                }

            });

            this.deletedDocuments.forEach(item =>{
                dataStore.deleteByBatch(DBBatch, this.CBADocsFileInfo, item.id);
            })
            this.deletedDocuments = [];
        },
        resetFormEx(){
            this.documents = []
            this.deletedDocuments = []
        }
    },
    watch:{
        fileUploadInfoGetter : function() {
            const uploadInfo = this.$store.state.fileUploadInfo;

            if(uploadInfo.status == 'New'){

               if(uploadInfo.parentInfo.type == 'CBA'){
                    this.documents.push(Utils.createFileInfoObjFromUploadWindowObj(uploadInfo));
               } 
               // Common
               this.fileUploadFileInfo.push(uploadInfo);
           }
           else if(uploadInfo.status == 'Delete_New' || uploadInfo.status == 'Delete'){
               if(uploadInfo.parentInfo.type == 'CBA'){
                    var bankDoc = Utils.findFromArray(this.documents, uploadInfo.id);
                    Utils.spliceArray(this.documents, uploadInfo.id)
                    Utils.spliceArray(this.fileUploadFileInfo, uploadInfo.id);

                    this.deletedDocuments.push(bankDoc)
               }                
           }
       },
    }
   
}
</script>

<style lang="scss">
</style>